import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Modal } from 'src/features/common';
import BankingDetailsOTPForm from '../banking-details-otp-form/banking-details-otp-form';
import BankingDetailsOTPSuccess from '../banking-details-otp-success/banking-details-otp-success';
import { paymentsDashboardRoute } from 'src/routing/routes';

type BankingDetailsOTPProps = {
  onRequestNewOTP: () => void;
  onExit: () => void;
};

const BankingDetailsOTP = ({ onRequestNewOTP, onExit }: BankingDetailsOTPProps) => {
  const history = useHistory();
  const [show, setShow] = useState<boolean>(true);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);

  function handleClose() {
    onExit();
    setShow(false);
  }

  function handleSuccess() {
    setShow(false);
    history.push(paymentsDashboardRoute);
  }

  return (
    <Modal visible={show} size="custom-small" onClose={handleClose}>
      <div
        className={`flex flex-col  ${
          showSuccess ? 'gap-10' : 'gap-2'
        }  items-center overflow-y-auto py-6 sm:py-0`}
      >
        {showSuccess ? (
          <BankingDetailsOTPSuccess onClick={handleSuccess} />
        ) : (
          <BankingDetailsOTPForm
            setShowSuccess={setShowSuccess}
            onRequestNewOTP={onRequestNewOTP}
          />
        )}
      </div>
    </Modal>
  );
};

export default BankingDetailsOTP;
